import { config } from '@/config/index';

import { ResponseStoredConfig } from '../types';

export const getStoredConfig = async (): Promise<ResponseStoredConfig> => {
  try {
    const response = await fetch(`${config.domain.frontAppBaseUrl}/links.json`);

    if (!response.ok) throw new Error('Network response was not ok');

    return await response.json();
  } catch (error) {
    console.error(
      "Please, provide the 'links.json' file in the 'public' folder! Now we use the fallback links from '/public/links.json.example'",
    );
    const response = await fetch('/links.json.example');
    return await response.json();
  }
};
